import { render } from "./ConfigurationTab.vue?vue&type=template&id=422c5100&scoped=true"
import script from "./ConfigurationTab.vue?vue&type=script&lang=js"
export * from "./ConfigurationTab.vue?vue&type=script&lang=js"

import "./ConfigurationTab.vue?vue&type=style&index=0&id=422c5100&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-422c5100"]])

export default __exports__